/**
 * Общие поля Schema.org Offer для аренды авто (Google Merchant / Product).
 * @see https://developers.google.com/search/docs/appearance/structured-data/product
 */

/** Политика отмены брони — релевантна для аренды (не «возврат товара»). */
export const RENTAL_MERCHANT_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy" as const,
  applicableCountry: "TJ",
  returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
  merchantReturnDays: 1,
  returnMethod: "https://schema.org/ReturnInStore",
  returnFees: "https://schema.org/ReturnFeesCustomerResponsibility",
};

export function buildRentalShippingDetails(
  currency: string,
  options?: { deliveryPrice?: number | null }
) {
  const deliveryRate =
    options?.deliveryPrice != null && Number(options.deliveryPrice) > 0
      ? Number(options.deliveryPrice)
      : 0;

  return {
    "@type": "OfferShippingDetails" as const,
    shippingRate: {
      "@type": "MonetaryAmount" as const,
      value: deliveryRate,
      currency,
    },
    deliveryTime: {
      "@type": "ShippingDeliveryTime" as const,
      handlingTime: {
        "@type": "QuantitativeValue" as const,
        minValue: 0,
        maxValue: 1,
        unitCode: "DAY",
      },
      transitTime: {
        "@type": "QuantitativeValue" as const,
        minValue: 0,
        maxValue: 2,
        unitCode: "DAY",
      },
    },
    shippingDestination: {
      "@type": "DefinedRegion" as const,
      addressCountry: "TJ",
    },
  };
}

export function buildRentalOfferExtras(
  currency: string,
  options?: { deliveryPrice?: number | null }
) {
  return {
    hasMerchantReturnPolicy: RENTAL_MERCHANT_RETURN_POLICY,
    shippingDetails: buildRentalShippingDetails(currency, options),
  };
}

/** Краткое описание для Product в каталоге (RU + EN + TG в одном тексте — лучше для мультиязычного поиска). */
export function buildCatalogProductDescription(car: {
  title: string;
  brand: string;
  model: string;
  year: number;
  price_per_day: number;
  currency: string;
}): string {
  return (
    `${car.title}. ${car.brand} ${car.model} ${car.year} — ` +
    `аренда от ${car.price_per_day} ${car.currency}/день в Таджикистане. ` +
    `Rent a car Dushanbe, car rental Tajikistan. ` +
    `Иҷораи мошин дар Душанбе ва Тоҷикистон — BeepBeep.tj.`
  );
}
